export function isDevelopment() {
  return import.meta.env.DEV;
}

export function isProduction() {
  return import.meta.env.PROD;
}

export function isLocalE2ETestMode() {
  return import.meta.env.VITE_APP_E2E_TEST_MODE === "local";
}

export const PublicUrl = import.meta.env.PUBLIC_URL;
